import { all, call } from "redux-saga/effects";

import watchCalendarSaga from "./calendar";

export function* promoCalendarSaga() {
	yield all([
		call(watchCalendarSaga),
	]);
}
